'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgValidate(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6.639-1.286l.008-.006.1.098-.01.007.04.049c.274.4.218.936-.156 1.281l-2.782 2.57 6.35 6.136c.374.361.415.927.1 1.34l.008.008-.1.098-.01-.008-.048.038a1.083 1.083 0 01-1.342-.127L1.81 3.435a.977.977 0 01.008-1.434l3.425-3.21a1.1 1.1 0 011.397-.077z", id: "Validate_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("g", { transform: "translate(2 3.5)" },
                React__default.default.createElement("path", { d: "M1.5 0h9v9h-9z" }),
                React__default.default.createElement("use", { fill: "currentColor", transform: "rotate(-90 6 4.5)", xlinkHref: "#Validate_svg__a" })))));
}

module.exports = SvgValidate;
//# sourceMappingURL=Validate.js.map
